<!-- footer section -->
<footer class="sticky">
	<div class="sub-footer border-top p-3">
		<div class="container">
			<div class="row">
				<div class="col-xl-8 col-md-9 col-sm-12">
					<div class="footer-end">
						<div class="copyright text-left">
							Copyright  ©  {{currentyear }}
							<span [innerHtml]="copyright"></span>
							, All rights reserved.
							<br>
							<span class="version">
								UI v. {{version.version}} {{env.production ? 'prod' : 'dev'}}
									({{version.hash}} {{version.date | date:'dd/MM/yy'}}
								<span *ngIf="version.tag">tag {{version.tag}}</span>
								)
							</span>
						</div>
					</div>
				</div>
				<div class="col-xl-4 col-md-3 col-sm-12">
					<div
						class="privacy-links"
						[innerHTML]="'privacy-link' | translate"></div>
				</div>
			</div>
		</div>
	</div>
</footer>
